import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadContext } from '../../store/actions/Contexto';
import {
  getEdicaoAnterior,
  isPeriodoInscricoes,
  isPeriodoPagamento,
  isPeriodoRegistroParticipacaoCadastroAlunos,
  isAfterInicioPeriodoRegistroParticipacaoCadastroAlunos,
  isAfterInicioPeriodoInserirNotaFase2,
  isPeriodoInserirNotaFase2,
  isPeriodoInscricoesPorModalidade,
} from '../../helper/ContextHelper';
import { locationEscolaParse } from '../../helper/ParseStateHelper';
import { download } from '../../helper/FileHelper';

import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import ReceiptIcon from '@material-ui/icons/Receipt';
import FormatListNumberedRtlIcon from '@material-ui/icons/FormatListNumberedRtl';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';
import { ButtonPrimary } from "../../components/Button/Button";
import Boxer from '../../components/Boxer/Boxer';
import Loading from '../../components/Loading/Loading';

import DadosEscola from '../../forms/Recibo/DadosEscola';
import DadosResponsavel from '../../forms/Recibo/DadosResponsavel';
import DialogChangePassword from '../../forms/Dialog/DialogChangePassword'

import AuthorizedElement from '../../security/AuthorizedElement';
import AuthorizedFunction from '../../security/AuthorizedFunction';
import {
  __DASHBOARD_DADOS_EDITAR,
  __DASHBOARD_RECIBO,
  __DASHBOARD_SENHA,
  __DASHBOARD_INSCRICAO_EDITAR,
  __DASHBOARD_INSCRICAO_ALUNOS_CLASSIFICADOS,
  __DASHBOARD_DOWNLOAD,
} from '../../security/RoleConfiguration';

import ArquivoService from '../../services/Arquivo';
import DashboardService from '../../services/Dashboard';
import EscolaService from "../../services/Escola";
import RelatorioService from '../../services/Relatorio';
import { errors } from '../../services/API';

import { Layout } from '../../layouts/private/Private';
import Alertas from './Alertas';
import Desempate from '../Premiados/Desempate';
import AlertaObjetoPostal from '../ObjetoPostal/AlertaObjetoPostal';

import { green } from '@material-ui/core/colors';

export const useStyles = makeStyles(theme => ({
  body: {
    margin: theme.spacing(3, 0),
  },
}));

const ButtonChangePassword = ({ openDialog }) => {
  return (
    <Grid item >
      <ButtonPrimary
        startIcon={<LockOutlinedIcon />}
        onClick={openDialog}
        name="Alterar Senha de Acesso"
      />
    </Grid>
  )
}

const ButtonEdit = ({ id }) => {
  return (
    <Grid item >
      <ButtonPrimary
        startIcon={<EditIcon />}
        to={{ pathname: `/admin/escola/${id}/responsavel/editar`, state: { escola: id } }}
        component={Link}
        name="Editar Dados do Responsável"
      />
    </Grid>
  )
}

const ButtonEditarInscricao = ({ id }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={4} className={classes.body}>
      <ButtonPrimary
        startIcon={<EditIcon />}
        to={{ pathname: `/admin/inscricao/${id}/editar`, state: { escola: id } }}
        component={Link}
        name="Editar Inscrição"
      />
    </Grid>
  )
}

const ButtonRealizarPagamento = ({ id, emAndamento, toast }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={4} className={classes.body}>
      { emAndamento === false ?
        <ButtonPrimary
          startIcon={<AccountBalanceWalletOutlinedIcon />}
          to={{ pathname: `/admin/inscricao/${id}/dadosDaFatura`, state: { escola: id } }}
          component={Link}
          name="Realizar Pagamento"
        /> 
      : 
        <ButtonPrimary
          startIcon={<AccountBalanceWalletOutlinedIcon />}
          onClick={() => redirecionaParaSisPag(id, toast)}
          name="Gerar Segunda Via do Boleto"
        />
      }
    </Grid>
  )
}

const redirecionaParaSisPag = (id,toast) => {
  EscolaService.buscaUrlDePagamento(id).then(resultado => {
      window.location.href = resultado.data;
  }).catch(error => {
    toast.setState({
      message: {
        message: "Ocorreu um erro, por favor tente novamente. Caso o erro persista entre em contato conosco. ",
        type: "error",
        open: true
      }
    })
  });
}

const redirecionaParaSisPagDadosPagamento = (id,toast) => {
  EscolaService.buscaUrlDeDadosDoPagamento(id).then(resultado => {
      window.location.href = resultado.data;
  }).catch(error => {
    toast.setState({
      message: {
        message: "Ocorreu um erro, por favor tente novamente. Caso o erro persista entre em contato conosco. ",
        type: "error",
        open: true
      }
    })
  });
}

const ButtonDadosDoPagamento = ({ id,toast }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={4} className={classes.body}>
      <ButtonPrimary
        startIcon={<ReceiptIcon />}
        onClick={() => redirecionaParaSisPagDadosPagamento(id,toast)}
        name="Dados do Pagamento"
      />
    </Grid>
  )
}

const ButtonRecibo = ({ id }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={2} className={classes.body}>
      <ButtonPrimary
        startIcon={<ReceiptIcon />}
        to={{ pathname: `/admin/inscricao/${id}/recibo`, state: { escola: id } }}
        component={Link}
        name="Recibo de Inscrição"
      />
    </Grid>
  )
}

const ButtonInformarAlunosClassificaveis = ({ id, contexts }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={4} className={classes.body}>
      <ButtonPrimary
        startIcon={<FormatListNumberedRtlIcon />}
        to={{ pathname: `/admin/inscricao/${id}/fase-2`, state: { escola: id } }}
        component={Link}
        name={`${isPeriodoRegistroParticipacaoCadastroAlunos(contexts) ? "Informar a" : ""} Quantidade de Alunos e os Classificados para a 2ª Fase`}
      />
    </Grid>
  )
}

const ButtonInformarNotaFase2Alunos = ({ id, contexts }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={4} className={classes.body}>
      <ButtonPrimary
        startIcon={<FormatListNumberedRtlIcon />}
        to={{ pathname: `/admin/inscricao/${id}/fase-2`, state: { escola: id } }}
        component={Link}
        name={`${isPeriodoInserirNotaFase2(contexts) ? "Informar Notas dos " : ""}Alunos na Fase 2`}
      />
    </Grid>
  )
}

export const ButtonListagemPremiados = ({ id }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={5} className={classes.body}>
      <ButtonPrimary
        startIcon={<FormatListNumberedRtlIcon />}
        to={{ pathname: `/admin/inscricao/${id}/premiados`, state: { escola: id } }}
        component={Link}
        name={`Listagem de Premiados`}
        style={{ backgroundColor: green[800] }}
      />
    </Grid>
  )
}

const ButtonDownload = ({ label, handleDownloadClick }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={4} className={classes.body}>
      <ButtonPrimary
        onClick={handleDownloadClick}
        name={label}
      />
    </Grid>
  )
}

const ButtonCertificadoEdicaoAnterior = ({ id }) => {
  const classes = useStyles();
  return (
    <Grid item sm={12} lg={4} className={classes.body}>
      <ButtonPrimary
        startIcon={<FormatListNumberedRtlIcon />}
        component="a"
        href={`${process.env.REACT_APP_PREV_EDITION_URL}admin/inscricao/${id}/fase-2`}
        target="_blank"
        name="Listagem de Alunos da Edição Anterior"
      />
    </Grid>
  )
}

export class Home extends Component {
  constructor() {
    super()
    this.state = {
      arquivos: [],
      responsavel: {
        email: '',
        cpf: '',
        nome: '',
        telefones: '',
        cargo: '',
      },
      escola: {
        cdEscola: '',
        dependenciaAdministrativa: '',
        cnpj: '',
        possuiConvenio: '',
        dependenciaConvenio: '',
        dependenciaAlunoConvenio: '',
        nome: '',
        uf: '',
        municipio: '',
        telefones: '',
        email: '',
        downloadFase2: false,
        inscricao: null,
        downloadCertificado: false,
        inscricaoConcluida: false,
        precisaRealizarPagamento: false,
        pagamentoEmAndamento: false,
        pagou: false,
        jaRealizouPremiacao: false,
        statusPremiacao: null,
        modalidade: null,
        downloadCertificadoEdicaoAnterior: false,
      },
      objetosPostaisMedalhas: [],
      objetosPostaisMaterialFase2: [],
      loading: true,
    }
  }

  // DECLARAÇÕES DE REFERENCIA DOS COMPONENTES
  setToast = t => this.Toast = t;
  setDesempate = d => this.Desempate = d;
  setDialogChangePassword = p => this.DialogChangePassword = p;

  // DOWNLOAD DE PROVA, GABARITO E CERTIFICADO 
  handleDownloadClick = (id) => {
    this.Toast.setState({
      message: {
        message: "Em Instantes o Download Iniciará Automáticamente",
        type: "info",
        open: true
      }
    });

    let request;

    if (this.state.arquivos.find(arquivo => arquivo.id === id).tipo === 'CERTIFICADO') {
      request = ArquivoService.certificado(this.state.escola.cdEscola);
    } else {
      request = ArquivoService.download(id);
    }

    request
      .then(res => download(res))
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      });
  }

  handleAtualizarObjetoPostalMedalhas = objetoPostal => {
    this.setState({
        ...this.state,
        objetosPostaisMedalhas: [
          ...this.state.objetosPostaisMedalhas.filter(obj => obj.numero !== objetoPostal.numero),
          objetoPostal,
        ],
    });
  }

  handleAtualizarObjetoPostalMaterialFase2 = objetoPostal => {
    this.setState({
        ...this.state,
        objetosPostaisMaterialFase2: [
          ...this.state.objetosPostaisMaterialFase2.filter(obj => obj.numero !== objetoPostal.numero),
          objetoPostal,
        ],
    });
  }

  // OPEN DIALOG DE TROCA DE SENHA
  handleOpenDialogChangePassword = () => this.DialogChangePassword.setState({ open: true, id: this.state.escola.cdEscola });

  componentDidMount() {
    this.carregarDashboard();
  }

  verificarSeHouveParticipacaoAlunosEdicaoAnterior = async (cdMecEscola) => {
    const lastEdition = getEdicaoAnterior(this.props.contexts);
    let comParticipacao = false;

    await RelatorioService.reportQtdAlunosSchoolPublicFromEdition(lastEdition, cdMecEscola)
      .then(res => {
        comParticipacao = res.status === 200 ? (res.data.qtdAlunosComNotaFase1 + res.data.qtdAlunosComNotaFase2) > 0 : false;
      });
    
    return comParticipacao;
  }
  
  carregarDashboard = async () => {
    this.props.loadContext();

    const f = locationEscolaParse(this.props.location);

    await DashboardService.init(f)
      .then(async (res) => {
        const downloadCertificadoEdicaoAnterior = await this.verificarSeHouveParticipacaoAlunosEdicaoAnterior(res.data.escola.cdMecEscola);

        this.setState({
          arquivos: [...res.data.arquivos],
          responsavel: {
            email: res.data.escola.responsavel.nmEmail,
            cpf: res.data.escola.responsavel.nmCpf,
            nome: res.data.escola.responsavel.nmNome,
            telefones: res.data.escola.responsavel.nmTelefonesFormatados,
            cargo: res.data.escola.responsavel.nmCargo,
          },
          escola: {
            cdEscola: res.data.escola.cdMecEscola,
            dependenciaAdministrativa: res.data.escola.nmDependenciaAdministrativa,
            cnpj: res.data.escola.cnpj,
            possuiConvenio: res.data.escola.possuiConvenio,
            dependenciaConvenio: res.data.escola.dependenciaConvenio,
            dependenciaAlunoConvenio: res.data.escola.dependenciaAlunoConvenio,
            nome: res.data.escola.nmEscola,
            uf: res.data.escola.endereco.municipio.uf.nmUf,
            municipio: res.data.escola.endereco.municipio.nmMunicipio,
            telefones: res.data.escola.nmTelefonesFormatados,
            email: res.data.escola.nmEmail,
            downloadFase2: res.data.escola.downloadFase2,
            inscricao: res.data.escola.inscricao,
            downloadCertificado: res.data.escola.downloadCertificado,
            inscricaoConcluida: res.data.escola.inscricaoConcluida,
            precisaRealizarPagamento: res.data.escola.precisaRealizarPagamento,
            pagamentoEmAndamento: res.data.escola.pagamentoEmAndamento,
            pagou: res.data.escola.pagou,
            jaRealizouPremiacao : res.data.escola.inscricao != null ? res.data.escola.inscricao.dataFinalizacaoLancamentoNotas != null : false,
            modalidade: res.data.escola.inscricao != null ? res.data.escola.inscricao.modalidadeInformada : null,
            downloadCertificadoEdicaoAnterior: downloadCertificadoEdicaoAnterior,
          },
          objetosPostaisMedalhas: [...res.data.objetosPostaisMedalhas],
          objetosPostaisMaterialFase2: [...res.data.objetosPostaisMaterialFase2]
        })
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      })
      .finally(() => this.setState({ loading: false }));
  }

  sizeBoxer = () => (!isPeriodoInscricoes(this.props.contexts) && AuthorizedFunction([__DASHBOARD_DADOS_EDITAR])) || AuthorizedFunction([__DASHBOARD_SENHA]) ? 5 : 6;

  verificaHabilitarPorQuantidadeAlunos = (habilitarSePossuiAlunos, qtdAlunos) => habilitarSePossuiAlunos ? qtdAlunos > 0 : false;

  verificaSeArquivoDeveAparecerNoBloco = (arquivo, tipo) => arquivo.localExibicao === tipo && arquivo.downloadAberto 
      && (this.verificaHabilitarPorQuantidadeAlunos(arquivo.exibirParaAlunosMirim1, this.state.escola.inscricao.mirim1.qtdAlunosPrevistos) 
        || this.verificaHabilitarPorQuantidadeAlunos(arquivo.exibirParaAlunosMirim2, this.state.escola.inscricao.mirim2.qtdAlunosPrevistos));

  verificarCasoSejaCertificadoSePodeSerExibido = (arquivo) => arquivo.tipo !== "CERTIFICADO" || (arquivo.tipo === "CERTIFICADO" && this.state.escola.downloadCertificado);

  render() {
    const page = 'Início';
    const links = [];
    const contexts = this.props.contexts;

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container >
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={page} />
          </Grid>
        </Grid>
        <Title>{page}</Title>

        <Grid container >
          {this.state.loading ?
            <Loading />
            :
            <>
              {this.state.escola.cdEscola &&
                <>
                  <Grid item sm={12} xs={this.sizeBoxer()} lg={this.sizeBoxer()} >
                    <DadosEscola escola={this.state.escola} />
                  </Grid>
                  <Grid item sm={12} xs={this.sizeBoxer()} lg={this.sizeBoxer()} >
                    <DadosResponsavel responsavel={this.state.responsavel} />
                  </Grid>

                  {((!isPeriodoInscricoes(contexts) && AuthorizedFunction([__DASHBOARD_DADOS_EDITAR])) || AuthorizedFunction([__DASHBOARD_SENHA])) &&
                    <Grid container item xs={2} lg={2} sm={12} justifycontent='flex-end' alignItems='center'>
                      {!isPeriodoInscricoes(contexts) && AuthorizedFunction([__DASHBOARD_DADOS_EDITAR]) &&
                        <ButtonEdit id={this.state.escola.cdEscola} />
                      }

                      <AuthorizedElement roles={[__DASHBOARD_SENHA]} >
                        <ButtonChangePassword openDialog={this.handleOpenDialogChangePassword} />
                        <DialogChangePassword
                            parentRef={this.setDialogChangePassword}
                            handleAtualizarSenha={EscolaService.atualizarSenha}
                        />
                      </AuthorizedElement>
                    </Grid>
                  }

                  <Alertas mec={this.state.escola.cdEscola} />

                  {this.state.escola && this.state.escola.inscricaoConcluida && this.state.escola.jaRealizouPremiacao && this.state.escola.inscricao.statusPremiacao &&
                    <Desempate parentRef={this.setDesempate} handleClose={this.carregarDashboard} mec={this.state.escola.cdEscola} statusPremiacao={this.state.escola.inscricao.statusPremiacao} />
                  }
                </>
              }

              {this.state.escola.inscricaoConcluida && (this.state.escola.jaRealizouPremiacao || this.state.objetosPostaisMedalhas.length > 0 || (AuthorizedFunction([__DASHBOARD_DOWNLOAD]) 
                  && this.state.arquivos.some(arquivo => this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "RELATORIO") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo)))) &&
                <Grid item xs={12}>
                  <Boxer category="Premiação">
                    {this.state.objetosPostaisMedalhas.length > 0 &&
                      <AlertaObjetoPostal objetos={this.state.objetosPostaisMedalhas} handleAtualizarObjetoPostal={this.handleAtualizarObjetoPostalMedalhas} />
                    }

                    {isAfterInicioPeriodoInserirNotaFase2(contexts) && this.state.escola.cdEscola && this.state.escola.jaRealizouPremiacao && AuthorizedFunction([__DASHBOARD_INSCRICAO_ALUNOS_CLASSIFICADOS]) &&
                      <ButtonListagemPremiados id={this.state.escola.cdEscola} />
                    }
                    
                    <AuthorizedElement roles={[__DASHBOARD_DOWNLOAD]}>
                      <Divider />

                      {this.state.arquivos.map(arquivo =>
                        <Fragment key={arquivo.id}>
                          {(this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "RELATORIO") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo)) &&
                            <ButtonDownload label={arquivo.nomeArquivo} handleDownloadClick={() => this.handleDownloadClick(arquivo.id)} />
                          }
                        </Fragment>
                      )}
                    </AuthorizedElement>
                  </Boxer>
                </Grid>
              }

              {this.state.escola.inscricaoConcluida && (this.state.objetosPostaisMaterialFase2.length > 0 
                || (isAfterInicioPeriodoInserirNotaFase2(contexts) && this.state.escola.cdEscola && AuthorizedFunction([__DASHBOARD_INSCRICAO_ALUNOS_CLASSIFICADOS]))
                || (this.state.escola.downloadFase2 && (AuthorizedFunction([__DASHBOARD_DOWNLOAD]) && this.state.arquivos.some(arquivo => this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "FASE_2") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo))))) && 
                <Grid item xs={12}>
                  <Boxer category="2ª Fase">
                    {this.state.objetosPostaisMaterialFase2.length > 0 &&
                      <AlertaObjetoPostal objetos={this.state.objetosPostaisMaterialFase2} handleAtualizarObjetoPostal={this.handleAtualizarObjetoPostalMaterialFase2} />
                    }

                    {isAfterInicioPeriodoInserirNotaFase2(contexts) && this.state.escola.cdEscola && AuthorizedFunction([__DASHBOARD_INSCRICAO_ALUNOS_CLASSIFICADOS]) &&
                      <ButtonInformarNotaFase2Alunos id={this.state.escola.cdEscola} contexts={contexts}/>
                    }

                    {this.state.escola.downloadFase2 && 
                      <AuthorizedElement roles={[__DASHBOARD_DOWNLOAD]}>
                        <Divider />

                        {this.state.arquivos.map(arquivo =>
                          <Fragment key={arquivo.id}>
                            {(this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "FASE_2") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo)) &&
                              <ButtonDownload label={arquivo.nomeArquivo} handleDownloadClick={() => this.handleDownloadClick(arquivo.id)} />
                            }
                          </Fragment>
                        )}
                      </AuthorizedElement>
                    }
                  </Boxer>
                </Grid>
              }

              {this.state.escola.inscricaoConcluida && ((isAfterInicioPeriodoRegistroParticipacaoCadastroAlunos(contexts) && this.state.escola.cdEscola && AuthorizedFunction([__DASHBOARD_INSCRICAO_ALUNOS_CLASSIFICADOS]))
                || (AuthorizedFunction([__DASHBOARD_DOWNLOAD]) && this.state.arquivos.some(arquivo => this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "FASE_1") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo)))) &&
                <Grid item xs={12}>
                  <Boxer category="1ª Fase">
                    {isAfterInicioPeriodoRegistroParticipacaoCadastroAlunos(contexts) && this.state.escola.cdEscola && AuthorizedFunction([__DASHBOARD_INSCRICAO_ALUNOS_CLASSIFICADOS]) &&
                      <ButtonInformarAlunosClassificaveis id={this.state.escola.cdEscola} contexts={contexts}/>
                    }

                    <AuthorizedElement roles={[__DASHBOARD_DOWNLOAD]}>
                      <Divider />

                      {this.state.arquivos.map(arquivo =>
                        <Fragment key={arquivo.id}>
                          {(this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "FASE_1") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo)) &&
                            <ButtonDownload label={arquivo.nomeArquivo} handleDownloadClick={() => this.handleDownloadClick(arquivo.id)} />
                          }
                        </Fragment>
                      )}
                    </AuthorizedElement>
                  </Boxer>
                </Grid>
              }

              {((((isPeriodoInscricoes(contexts) || isPeriodoInscricoesPorModalidade(this.props.contexts, this.state.escola.modalidade)) 
                  && this.state.escola.cdEscola && AuthorizedFunction([__DASHBOARD_INSCRICAO_EDITAR]))
                || (this.state.escola.cdEscola && AuthorizedFunction([__DASHBOARD_RECIBO])))
                || (AuthorizedFunction([__DASHBOARD_DOWNLOAD]) && this.state.arquivos.some(arquivo => this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "INSCRICAO") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo)))) &&
                <Grid item xs={12}>
                  <Boxer category="Inscrição">
                    {(isPeriodoInscricoes(contexts) || isPeriodoInscricoesPorModalidade(this.props.contexts, this.state.escola.modalidade)) 
                        && this.state.escola.cdEscola && this.state.escola.pagou === false &&
                      <AuthorizedElement roles={[__DASHBOARD_INSCRICAO_EDITAR]}>
                        <ButtonEditarInscricao id={this.state.escola.cdEscola} />
                      </AuthorizedElement>
                    }

                    {this.state.escola.cdEscola &&
                      <AuthorizedElement roles={[__DASHBOARD_RECIBO]}>
                        <ButtonRecibo id={this.state.escola.cdEscola} />
                      </AuthorizedElement>
                    }                 
                    
                    {isPeriodoPagamento(contexts) && this.state.escola.cdEscola && this.state.escola.precisaRealizarPagamento === true &&
                      <AuthorizedElement roles={[__DASHBOARD_INSCRICAO_EDITAR]}>
                        {this.state.escola.pagou === false && <ButtonRealizarPagamento id={this.state.escola.cdEscola} emAndamento={this.state.escola.pagamentoEmAndamento} toast={this.Toast} />}
                      </AuthorizedElement>
                    }

                    {this.state.escola.cdEscola && this.state.escola.pagou === true &&
                      <AuthorizedElement roles={[__DASHBOARD_INSCRICAO_EDITAR]}>
                        <ButtonDadosDoPagamento id={this.state.escola.cdEscola} toast={this.Toast} />
                      </AuthorizedElement>
                    }

                    <AuthorizedElement roles={[__DASHBOARD_DOWNLOAD]}>
                      <Divider />

                      {this.state.arquivos.map(arquivo =>
                        <Fragment key={arquivo.id}>
                          {(this.verificaSeArquivoDeveAparecerNoBloco(arquivo, "INSCRICAO") && this.verificarCasoSejaCertificadoSePodeSerExibido(arquivo)) &&
                            <ButtonDownload label={arquivo.nomeArquivo} handleDownloadClick={() => this.handleDownloadClick(arquivo.id)} />
                          }
                        </Fragment>
                      )}
                    </AuthorizedElement>
                  </Boxer>
                </Grid>
              }              

              {(this.state.escola.cdEscola && this.state.escola.downloadCertificadoEdicaoAnterior && AuthorizedFunction([__DASHBOARD_INSCRICAO_ALUNOS_CLASSIFICADOS])) &&
                <Grid item xs={12}>
                  <Boxer category="Edição Anterior">
                    <ButtonCertificadoEdicaoAnterior id={this.state.escola.cdEscola} />
                  </Boxer>
                </Grid>
              }
            </>
          }
        </Grid>
      </Layout>
    )
  }
}

const mapStateToProps = state => ({ contexts: state.contexts });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadContext }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));